//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class NoticeTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[NoticeType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/notification/notice-type/detail', {'params':params});
	};

	//GeneratorFlag:[NoticeType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/notification/notice-type/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}